import { render } from "./AddedToBag.vue?vue&type=template&id=5665da8b&scoped=true"
import script from "./AddedToBag.vue?vue&type=script&lang=js"
export * from "./AddedToBag.vue?vue&type=script&lang=js"

import "./AddedToBag.vue?vue&type=style&index=0&id=5665da8b&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5665da8b"]])

export default __exports__